module.exports = __webpack_public_path__ + "static/img/power_off.d931b24.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/air_se_2021/power_off.png
// module id = 3uwa
// module chunks = 1